/*
 * @Author: heyouqin@moyi365.com
 * @LastEditors: oujinfa oujinfa@100efly.com
 * @Date: 2024-01-25 14:12:02
 * @LastEditTime: 2024-04-29 17:38:14
 * @Descripttion: file content
 */

import {takeEvery, put, select, call} from 'redux-saga/effects'
import {homeworkAction} from '../action'
import {MODE} from '@/utils/const'
import {BookInfoType, BookType, UnitQue, UnitType, UserCacheDataType, AreaType} from '@/types/homework'
import api from '@/api'
import {HomeworkDefaultStateType, defQuesType, defSections, initModeData} from '../state/homework'
import {QuePubType} from '@/types/question'
import {copy} from '@/utils/copy'
import {DubbingDataType, PaperDetail} from '@/types/api'

export default function* listenSaga() {
	yield takeEvery(homeworkAction.CHECK_MODE, function* ({payload: mode}: {type: string; payload: MODE}): any {
		const state = (yield select(state => state.homework)) as HomeworkDefaultStateType
		const modeData = state.data[mode]
		yield put({
			type: homeworkAction.RESET_QUE_LIST
		})
		yield put({type: homeworkAction.SET_MODE, payload: mode})
		if (modeData && modeData.book_id) {
			if (mode === MODE.HOMEWORK_TRAIN || mode === MODE.HOMEWORK_UNFINISH) {
				yield put({
					type: homeworkAction.GET_UNIT_LIST
				})
			} else if (mode === MODE.HOMEWORK_PAPER) {
				yield put({
					type: homeworkAction.GET_EXAM_LIST
				})
			}
		} else {
			!modeData &&
				(yield put({
					type: homeworkAction.UPDATE_MODE_DATA,
					payload: {...state.data, [mode]: copy(initModeData)}
				}))
		}
	})
	yield takeEvery(
		homeworkAction.SET_BOOK_ID,
		function* ({payload}: {type: string; payload: {book: BookType; mode: MODE}}): any {
			const {mode, book} = payload
			const state = (yield select(state => state.homework)) as HomeworkDefaultStateType
			yield put({
				type: homeworkAction.UPDATE_MODE_DATA,
				payload: {
					...state.data,
					[mode]: {
						...copy(initModeData),
						...book
					}
				}
			})
			yield put({
				type: homeworkAction.UPDATE,
				payload: {
					que_total: 0,
					ques_loading: true,
					que_page: 1,
					que_ids: [],
					ques: [],
					que_load_end: false
				}
			})
			if (state.mode === MODE.HOMEWORK_TRAIN || state.mode === MODE.HOMEWORK_UNFINISH) {
				yield put({
					type: homeworkAction.GET_UNIT_LIST
				})
			} else if (state.mode === MODE.HOMEWORK_PAPER) {
				yield put({
					type: homeworkAction.GET_EXAM_LIST
				})
			}
		}
	)
	yield takeEvery(homeworkAction.GET_UNIT_LIST, function* (): any {
		yield put({
			type: homeworkAction.UPDATE,
			payload: {
				unit_loading: true
			}
		})
		const state = (yield select(state => state.homework)) as HomeworkDefaultStateType
		const modeData = state.data[state.mode]
		const unit_list = (yield call(api.getUnits, modeData.book_id, state.mode)) as UnitType[]

		yield put({
			type: homeworkAction.UPDATE,
			payload: {
				unit_list,
				unit_loading: false
			}
		})
		yield put({
			type: homeworkAction.SET_MODE_DATA,
			payload: {
				unit_id: unit_list[0].id
			}
		})

		yield put({
			type: homeworkAction.GET_QUE_LIST
		})
	})
	yield takeEvery(
		homeworkAction.GET_QUES_LIST,
		function* ({
			payload
		}: {
			type: string
			payload: {grade: number; published: number; exam_type: number; is_vip: number; tag_id: number}
		}): any {
			yield put({
				type: homeworkAction.UPDATE,
				payload: {
					unit_loading: true
				}
			})
			const unit_list = (yield call(api.getQuesList, {...payload})) as UnitType[]
			if (unit_list.length === 0) {
				yield put({
					type: homeworkAction.UPDATE,
					payload: {
						que_total: 0,
						ques_loading: false,
						que_page: 1,
						que_ids: [],
						ques: [],
						que_load_end: true
					}
				})
				return
			}
			yield put({
				type: homeworkAction.UPDATE,
				payload: {
					unit_list,
					unit_loading: false,
					que_ids: unit_list[0].ques_ids || []
				}
			})

			// yield put({
			// 	type: homeworkAction.SET_MODE_DATA,
			// 	payload: {
			// 		unit_id: unit_list[0].tag_id
			// 	}
			// })

			yield put({
				type: homeworkAction.GET_QUE_LIST
			})
		}
	)
	yield takeEvery(homeworkAction.GET_EXAM_LIST, function* (): any {
		yield put({
			type: homeworkAction.UPDATE,
			payload: {
				unit_loading: true
			}
		})
		const state = (yield select(state => state.homework)) as HomeworkDefaultStateType
		const modeData = state.data[state.mode]

		const unit_list = (yield call(api.getExamList, modeData.book_id)) as UnitType[]
		unit_list.forEach((_: any) => {
			_.master_exam_id = _.id
			_.is_published = _.is_published ? 1 : 0
			return _
		})

		yield put({
			type: homeworkAction.UPDATE,
			payload: {
				unit_list,
				unit_loading: false
			}
		})
		yield put({
			type: homeworkAction.SET_MODE_DATA,
			payload: {
				unit_name: unit_list[0].name,
				unit_id: unit_list[0].id,
				master_exam_id: unit_list[0].id,
				is_vip: unit_list[0].is_vip,
				published: unit_list[0].is_published
			}
		})
		yield put({
			type: homeworkAction.GET_PAPER_DETAIL
		})
	})
	yield takeEvery(homeworkAction.GET_PAPER_DETAIL, function* (): any {
		yield put({
			type: homeworkAction.UPDATE,
			payload: {
				ques_loading: true
			}
		})
		const state = (yield select(state => state.homework)) as HomeworkDefaultStateType
		const modeData = state.data[state.mode]

		const {ques} = (yield call(api.getPaperDetail, modeData.unit_id)) as any

		ques.forEach((que: any) => {
			que.time = Math.ceil(que.duration / 60)
			que.topic = que
		})

		yield put({
			type: homeworkAction.UPDATE,
			payload: {
				ques: ques.map((item: any) => ({...item, is_vip: modeData.is_vip, published: item.is_publish ? 1 : 0})),
				que_total: ques.length,
				ques_loading: false,
				que_load_end: true,
				que_page: state.que_page + 1
			}
		})
	})
	yield takeEvery(
		homeworkAction.GET_PHONETICS,
		function* ({
			payload
		}: {
			type: string
			payload: {
				type: number
				published: number
			}
		}): any {
			yield put({
				type: homeworkAction.UPDATE,
				payload: {
					ques_loading: true
				}
			})
			const state = (yield select(state => state.homework)) as HomeworkDefaultStateType

			const ques = (yield call(api.getPhonetics, payload)) as {list: QuePubType[]}

			yield put({
				type: homeworkAction.UPDATE,
				payload: {
					ques: ques.list.map(item => ({
						...item,
						name: item.topic.title,
						id: item.ques_id,
						time: Math.ceil(item.answer_time / 60)
					})),
					que_total: ques.list.length,
					ques_loading: false,
					que_load_end: true,
					que_page: state.que_page + 1
				}
			})
		}
	)
	yield takeEvery(
		homeworkAction.GET_DUBBING,
		function* ({
			payload
		}: {
			type: string
			payload: {
				grade: number
				is_published: number
				category: number
				page: number
			}
		}): any {
			yield put({
				type: homeworkAction.UPDATE,
				payload: {
					ques_loading: true
				}
			})
			const state = (yield select(state => state.homework)) as HomeworkDefaultStateType

			const list = (yield call(api.getDubbing, {...payload})) as DubbingDataType
			let ques = list.data.map(item => ({
				...item,
				name: item.topic.title,
				id: item.ques_id,
				time: Math.ceil(item.answer_time / 60)
			}))
			if (state.que_page !== 1) {
				ques = [...state.ques, ...ques]
			}

			yield put({
				type: homeworkAction.UPDATE,
				payload: {
					ques,
					que_total: list.total,
					ques_loading: false,
					que_page: state.que_page + 1,
					que_load_end: list.current_page === list.last_page
				}
			})
		}
	)
	yield takeEvery(homeworkAction.GET_QUE_LIST, function* (): any {
		const state = (yield select(state => state.homework)) as HomeworkDefaultStateType
		const modeData = state.data[state.mode]
		let ques: QuePubType[] = state.ques
		let unit_ques: UnitQue[] = []
		let ids = state.que_ids

		yield put({
			type: homeworkAction.UPDATE,
			payload: {
				ques_loading: true
			}
		})
		if (
			state.mode === MODE.HOMEWORK_UNFINISH ||
			state.mode === MODE.HOMEWORK_TRAIN ||
			state.mode === MODE.HOMEWORK_QUES
		) {
			if (state.que_page === 1) {
				const modeData = state.data[state.mode] as UserCacheDataType
				const filter_published = modeData.filter_published
				const biz = modeData.que_type.biz
				const sectionId = modeData.section.id
				if (state.mode === MODE.HOMEWORK_UNFINISH || state.mode === MODE.HOMEWORK_TRAIN) {
					unit_ques = (state.unit_list as UnitType[])
						.filter(unit => unit.id === modeData.unit_id)[0]
						?.ques.filter(unit => (sectionId === 0 ? unit : unit.section_id === sectionId))
						.filter(unit => (biz === 0 ? unit : unit.biz === biz))
						.filter(unit => (filter_published ? unit.published !== 1 : unit))
					ids = unit_ques.map(unit => ({id: unit.id}))
				}
			}

			// 过滤后题目数据为空
			if (ids.length === 0) {
				yield put({
					type: homeworkAction.UPDATE,
					payload: {
						que_total: ids.length,
						ques_loading: false,
						que_page: 1,
						que_ids: [],
						ques: [],
						que_load_end: true
					}
				})
				return
			}

			const data = (yield call(
				api.getQuesDetails,
				ids.map(item => item.id).slice((state.que_page - 1) * state.que_limit, state.que_page * state.que_limit),
				state.que_page - 1,
				state.mode
			)) as QuePubType[]
			data.forEach(item => {
				if (state.mode === MODE.HOMEWORK_UNFINISH || state.mode === MODE.HOMEWORK_TRAIN) {
					modeData.content &&
						modeData.content[0].questions?.forEach(que => {
							if (que.ques_id === item.id) {
								item.is_join = true
							}
						})
					item.is_vip = !!item.is_vip
					// item.published = que.published
				} else {
					item.is_vip = !!ids.filter(info => info.id === item.id)[0].is_vip
				}
				item.published = item.is_published
				item.master_ques_id = item.ques_id
				item.master_exam_id = 0
				item.exam_id = 0
				item.ques_id = item.id
				if (item.topic) {
					item.content = item.topic
				} else {
					item.topic = item.content
				}
			})
			ques = [...ques, ...data]
		}
		yield put({
			type: homeworkAction.UPDATE,
			payload: {
				ques,
				que_ids: ids,
				que_total: ids.length,
				ques_loading: false,
				que_load_end: (state.que_page - 1) * state.que_limit >= ids.length || ids.length <= state.que_limit,
				que_page: state.que_page + 1
			}
		})
	})
	yield takeEvery(homeworkAction.RESET_QUE_LIST, function* (): any {
		yield put({
			type: homeworkAction.UPDATE,
			payload: {
				que_total: 0,
				ques_loading: true,
				que_page: 1,
				que_ids: [],
				ques: [],
				que_load_end: false
			}
		})
	})
	yield takeEvery(homeworkAction.CHECK_UNIT_ID, function* ({payload}: {type: string; payload: number}): any {
		yield put({
			type: homeworkAction.SET_MODE_DATA,
			payload: {
				section: defSections,
				que_type: defQuesType,
				filter_published: false,
				unit_id: payload
			}
		})
		yield put({
			type: homeworkAction.RESET_QUE_LIST
		})
	})
	yield takeEvery(homeworkAction.JOIN_OR_REMOVE_QUE, function* ({payload}: {type: string; payload: QuePubType}): any {
		const state = (yield select(state => state.homework)) as HomeworkDefaultStateType
		const modeData = state.data[state.mode]
		const is_join = payload.is_join
		const total = modeData.total + (is_join ? -1 : 1)
		const time = payload.time * (is_join ? -1 : 1) + modeData.time
		let book_id = modeData.book_id
		let category_id = modeData.category_id
		let unit_id = modeData.unit_id
		const grade_name = modeData.grade_name
		let section_id = modeData.section_id

		if (state.mode === MODE.HOMEWORK_SOUNDMARK || state.mode === MODE.HOMEWORK_DUBBING) {
			book_id = payload.book_id
			category_id = payload.category_id
			unit_id = payload.unit_id
			section_id = payload.section_id
		}

		const content = modeData.content
		let book_info = modeData.book_info
		const ques = state.ques.map(q => {
			if (q.id === payload.id) {
				q.is_join = !q.is_join
			}
			return q
		})
		const verifBookInfo = (item: BookInfoType) => {
			return (
				item.section_id === payload.section_id &&
				item.book_id === book_id &&
				item.category_id === category_id &&
				item.unit_id === unit_id &&
				item.grade_name === grade_name &&
				item.section_id === section_id
			)
		}

		if (is_join) {
			content[0].questions = content[0].questions!.filter(que => que.ques_id !== payload.ques_id)
			book_info.forEach(item => {
				if (verifBookInfo(item)) {
					item.ques_ids = item.ques_ids.filter(q => q !== payload.ques_id)
					if (item.ques_ids.length === 0) {
						book_info = book_info.filter(info => info.ques_ids.length !== 0)
					}
				}
			})
		} else {
			if (book_info.length === 0) {
				book_info.push({
					book_id,
					category_id,
					grade_name,
					ques_ids: [payload.ques_id],
					section_id,
					unit_id,
					id: payload.id
				})
			} else {
				// book_info.forEach(item => {
				// 	// 修改ques_id合并逻辑
				// 	console.log(item, payload, 333)
				// 	if (item.section_id === payload.section_id) {
				// 		item.ques_ids.push(payload.ques_id)
				// 	} else {
				// 		book_info.push({
				// 			book_id,
				// 			category_id,
				// 			grade_name,
				// 			ques_ids: [payload.ques_id],
				// 			section_id,
				// 			unit_id
				// 		})
				// 	}
				// })
				const bookInfoItem = book_info.find(b => b.section_id === payload.section_id)
				if (bookInfoItem) {
					bookInfoItem.ques_ids.push(payload.ques_id)
				} else {
					book_info.push({
						book_id,
						category_id,
						grade_name,
						ques_ids: [payload.ques_id],
						section_id,
						unit_id,
						id: payload.id
					})
				}
			}
			content[0].questions?.push({
				biz: payload.biz,
				is_vip: payload.is_vip,
				master_ques_id: payload.master_ques_id,
				ques_id: payload.ques_id
			})
		}

		content[0].have_vip = content[0].questions?.filter(item => item.is_vip).length !== 0

		yield put({
			type: homeworkAction.SET_MODE_DATA,
			payload: {
				content,
				book_info,
				total,
				time
			}
		})
		yield put({
			type: homeworkAction.UPDATE,
			payload: {
				ques
			}
		})
	})
	yield takeEvery(homeworkAction.CLEAR_MODE_SELECT_DATA, function* () {
		const state = (yield select(state => state.homework)) as HomeworkDefaultStateType
		const ques = state.ques.map(item => ({...item, is_join: false}))

		yield put({
			type: homeworkAction.SET_MODE_DATA,
			payload: {
				filter_published: initModeData.filter_published,
				total: initModeData.total,
				time: initModeData.time,
				content: copy(initModeData.content),
				book_info: copy(initModeData.book_info)
			}
		})
		yield put({
			type: homeworkAction.UPDATE,
			payload: {ques}
		})
	})
	yield takeEvery(
		homeworkAction.GET_AREA_TREE,
		function* ({payload}: {type: string; payload: {province_id: number; city_id: number}}): any {
			const list = (yield call(api.getAreaList, {...payload})) as AreaType[]
			const areaList = list.map(area => {
				return {
					value: Number(area.id),
					label: area.name,
					isLeaf: payload.city_id > 0
				}
			})
			yield put({
				type: homeworkAction.SET_AREA_TREE,
				payload: {
					...payload,
					areaList
				}
			})
		}
	)
}
